export default "__VITE_ASSET__CsZk1UdL__"